<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-terms"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head"
                    :class="[{'mass-terms': theme == 'mass'},{'prestige-terms': theme == 'prestige'}]">
                    <div class="modal-base-close">
                        <img class="close-img" src="@/assets/icon/prestige/ic-close.svg"
                            @click="clickClose" />
                    </div>
                </div>
                <div class="modal-base-body"
                    :class="[{'mass-terms': theme == 'mass'},{'prestige-terms': theme == 'prestige'}]">
                    <p v-html="termsContentTxt"></p>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//core
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
//helper
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: 'TermsModal',
    mixins: [LocaleMixin],
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
    },
    props: {
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            tag: '',
            termsContent: '',

            termsHeadline: '',
            termsContentTxt: '',

            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickClose: function () {
            this.hide();
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        //method
        intialTerms: function () {
            if (this.termsContent == 'terms') {
                this.termsHeadline = this.theme == 'mass'
                                    ? Util.newLineToBr(this.lbl.terms.terms_headline.mass)
                                    : Util.newLineToBr(this.lbl.terms.terms_headline.prestige);
            } else {
                this.termsHeadline = Util.newLineToBr(this.lbl.terms.privilege_headline);
            }

            BzbsPDPA.apiGetPDPAVersion()
                .then(res => {
                    var version = res.data[this.theme].terms.current_version;
                    return BzbsPDPA.apiGetPDPAContent(this.termsContent, this.theme, version, this.localeCode)
                }).then(res => {
                    this.termsContentTxt = Util.newLineToBr(res.data);
                    this.$nextTick(() => {
                        this.$bvModal.show(this.modalId);
                    });
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.error) {
                        var error = err.response.data.error;
                        this.controller.alertModal
                                .clearModal()
                                .setMsg(error.message)
                                .show();
                    } else {
                        if (this.controller.noInternetModal != null) {
                            var lblDefault = Locale.getLbl().default;
                            this.controller.noInternetModal
                                .clearModal()
                                .setMsg(lblDefault.no_internet)
                                .show();
                        }
                    }
                });
        },
        //modal control
        show: function (config) {
            this.tag = config.tag;
            this.termsContent = config.termsContent;
            this.intialTerms();
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-terms {
    @extend %modal-base;

    .modal-dialog {
        width: 90%;
        margin: {
            left: auto;
            right: auto;
        };
    }

    p {
        margin-bottom: 0;
    }

    .modal-base {
        .modal-base-head {
            .modal-base-close {
                position: relative;
                height: 20px;
                margin-bottom: 20px;

                .close-img {
                    position: absolute;
                    display: block;
                    top: 0;
                    bottom: 0;
                    right: 6px;
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }

    .modal-base-body {
        .pdpa-header {
            padding: {
                left: 20px;
                right: 20px;
                bottom: 25px;
            };
            font-size: 1.45rem;
            // font-family: $heading;
            // line-height: 1;
            text-align: center;
            word-break: break-word;
        }

        .pdpa-txt {
            margin-bottom: 15px;
            font-size: 1.15rem;
            // line-height: 1.1;

            a {
                text-decoration: none;
            }
        }

        .pdpa-remark {
            margin-bottom: 15px;
            font-size: 1rem;
            // line-height: 1.1;

            a {
                text-decoration: none;
            }
        }

        .pdpa-table {
            width: 100%;
            margin: {
                top: 10px;
                bottom: 15px;
            };
            //font
            font-size: 1.25rem;
            // font-family: $heading;
            text-align: center;

            .pdpa-row {

                .pdpa-col {
                    padding: 10px 7px;
                    border: 1px solid #707070;
                }
            }
        }

        &.mass-terms {
            p {
                color: $mass_detail_font_color;

                a {
                    color: $mass_detail_font_color;
                }
            }

            .pdpa-table {
                thead {
                    color: #ffffff;
                    background: $mass_theme_color;
                }

                tbody {
                    color: $mass_detail_font_color;
                    background: #ffffff;
                }
            }
        }

        &.prestige-terms {
            p {
                color: $prestige_font_color;

                a {
                    color: $prestige_font_color;
                }
            }

            .pdpa-table {
                thead {
                    color: #ffffff;
                    background: $prestige_font_color;
                }

                tbody {
                    color: $prestige_font_color;
                    background: #eee9de;
                }
            }
        }
    }
}
</style>
